import { useParams } from 'react-router-dom';

const ProductDetail = () => {
  const { id } = useParams();
  
  return (
    <div className="min-h-screen p-6 md:p-8" data-testid="product-detail">
      <div className="max-w-4xl mx-auto glass-card p-8 text-center">
        <p className="text-[#8a948a]">Product detail page coming soon</p>
      </div>
    </div>
  );
};

export default ProductDetail;
